import { ADMIN_MUTATION_HEADER } from '@trendator/shared';

export class ApiError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly body: Record<string, unknown> = {},
  ) {
    super(message);
  }
}

/** Слушатель «сессия кончилась» — App показывает вход. */
let onUnauthorized: () => void = () => {};
export const setUnauthorizedHandler = (fn: () => void) => {
  onUnauthorized = fn;
};

const MESSAGES: Record<string, string> = {
  csrf: 'Запрос отклонён',
  not_found: 'Не найдено',
  bad_request: 'Проверь поля',
  admin_disabled: 'Админка выключена на сервере',
  generations_disabled: 'Очередь не настроена',
  uploads_disabled: 'S3 не настроен',
};

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const isForm = body instanceof FormData;
  const res = await fetch(`/admin${path}`, {
    method,
    credentials: 'same-origin',
    headers: {
      ...(method === 'GET' ? {} : { [ADMIN_MUTATION_HEADER]: '1' }),
      ...(body !== undefined && !isForm ? { 'content-type': 'application/json' } : {}),
    },
    body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
  });
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    if (res.status === 401 && !path.startsWith('/auth/')) onUnauthorized();
    const code = String(data.error ?? res.status);
    const issues = Array.isArray(data.issues) ? (data.issues as { message: string }[]).map((i) => i.message).join('; ') : '';
    throw new ApiError(res.status, code, String(data.message ?? (issues || MESSAGES[code] || `Ошибка ${res.status}`)), data);
  }
  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body: unknown = {}) => request<T>('POST', path, body),
  patch: <T>(path: string, body: unknown) => request<T>('PATCH', path, body),
  put: <T>(path: string, body: unknown) => request<T>('PUT', path, body),
  upload: <T>(path: string, file: File) => {
    const fd = new FormData();
    fd.append('file', file);
    return request<T>('POST', path, fd);
  },
};

export const errorText = (err: unknown) => (err instanceof Error ? err.message : 'Что-то пошло не так');
